<template>

  <div class="content">

    <div class="profile">

      <h2>Personal Details</h2>

      <!-- User Info - Profile Pic, Name, Email, Change Password -->
      <template v-if="edited_user">

        <div class="row profile-pic">
          <p class="label">Photo</p>
          <div class="profile-pic-img" v-bind:style="{ backgroundImage: 'url(' + (edited_user.profile_pic || 'https://api-outsidevoice.vercel.app/public/default-profile.svg') + ')' }"></div>
          <label class="upload-image upload-btn">
            {{ !edited_user.profile_pic ? 'Upload Photo' : 'Change Photo'}}
            <input @change="uploadProfilePicture($event)" type="file" ref="file" accept="image/png, image/jpeg" />
          </label>
        </div>

        <div class="row">
          <p class="label">Full Name</p>
          <input
          v-model="edited_user.name"
          placeholder="Your full name" maxlength="100" type="text">
        </div>

        <div class="row email">
          <p class="label">Email</p>
          <input
          readonly
          :value="edited_user.email"
          type="text">
        </div>

        <button v-if="is_edits" @click="saveEdits()" class="save-edits-btn">Save Edits</button>

      </template>

      <center v-if="!edited_user">
        <a-spin>
          <a-icon slot="indicator" type="loading" style="font-size: 40px; color: #1BD285;" spin />
        </a-spin>
      </center>

    </div>

    <div class="notifications">

      <h2>📫 Notifications</h2>

      <div class="row">
        <div class="text">
          <p>Product Updates</p>
          <p>Learn about our newest features and how you can use them</p>
        </div>
        <div @click="toggleNotification(0)" class="toggle-outer">
          <div class="toggle-inner" :class="{ active: notifications[0] }"></div>
        </div>
      </div>

      <div class="row">
        <div class="text">
          <p>New Responses Notifications</p>
          <p>Get notified when respondents start answering your survey</p>
        </div>
        <div @click="toggleNotification(1)" class="toggle-outer">
          <div class="toggle-inner" :class="{ active: notifications[1] }"></div>
        </div>
      </div>

    </div>

  </div>

</template>

<script>

import Compressor from 'compressorjs';
import moment from 'moment';
import { db_helper } from '../../store/db_helper.js';

export default {

  name: 'General',

  data: function () {

    let edited_user;

    if (this.$store.state.user.email) {
      edited_user = JSON.parse(JSON.stringify(this.$store.state.user));
    };

    return ({
      edited_user,
      notifications: { // TODO: fetch actual notification preferences from firebase
        0: false,
        1: false
      }
    });

  },
  computed: {

    user() {
      return this.$store.state.user;
    },

    is_edits() {
      return (this.edited_user.name !== this.user.name || this.edited_user.profile_pic !== this.user.profile_pic);
    }

  },

  components: {},

  methods: {

    uploadProfilePicture(event) {

      // Load the image preview immediately
      let file = event.target.files[0];
      var reader = new FileReader();
      reader.onload = (e) => {
        let local_path = e.target.result;
        this.edited_user.profile_pic = local_path;
      };
      reader.readAsDataURL(file);

      let that = this;

      // Compress and upload the file to GCS
      new Compressor(file, {
        quality: 0.7,
        convertSize: 500000, // Convert PNG's over 0.5mb to JPG's
        success(result) {
          let random_id = db_helper.getRandomID();
          let media_ref = that.$storage.child(random_id);
          media_ref.put(result).then((snapshot) => {
            let media_url = `https://storage.googleapis.com/outside-voice-a1d45.appspot.com/${random_id}`;
            that.edited_user.profile_pic = media_url;
            that.$forceUpdate();
          });
        },
        error(err) {
          console.log(err.message);
        }
      });
    },


    saveEdits() {

      let updates = {};

      if (this.user.name !== this.edited_user.name && this.edited_user.name !== '') {
        updates.name = this.edited_user.name;
        let names = updates.name.split(' ');
        updates.first_name = names[0];
        updates.last_name = '';
        if (names.length > 1) {
          updates.last_name = names[names.length - 1];
        };
      };

      if (this.edited_user.profile_pic !== this.user.profile_pic && this.edited_user.profile_pic !== '') {
        updates.profile_pic = this.edited_user.profile_pic;
      };

      if (!_.isEmpty(updates)) {
        this.$store.dispatch('updateUser', updates);
        this.$notification.open({
          message: 'Changes Saved.',
          description: `You've successfully saved changes to your profile.`,
          placement: 'bottomRight',
          icon: <a-icon type="check-circle" theme="twoTone" two-tone-color="#52c41a" />
        });
        analytics.track('Profile Edited');
      };

    },

    toggleNotification: function(notification_index) {
      this.notifications[notification_index] = !this.notifications[notification_index];
      // TODO: Save automatically, and show quick notification.
    },

    setupDemo() {
      Calendly.initPopupWidget({url: 'https://calendly.com/outside-voice/intro'})
    }

  },

  mounted() {

    // Wait 0.75s for user to load, otherwise redirect back to home.
    if (!this.$store.state.user.email) {
      var that = this;
      setTimeout(function() {
        if (!that.$store.state.user.email) {
          that.$router.replace('/surveys');
        } else {
          that.edited_user = JSON.parse(JSON.stringify(that.$store.state.user));
        };
      }, 750);
    };
  },

  created() {
    analytics.page('Settings');
  }

}
</script>

<style scoped lang="scss">

h2{
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 35px;
}

.content > div{
  padding: 50px 10% 40px 10%;
  border-bottom: 1px solid rgb(220,220,220);
}

.profile{
  padding: 40px 10% 45px 10%;
  border-bottom: 1px solid rgb(220,220,220);
  .row{
    margin-bottom: 25px;
    padding-left: 20%;
    & > *{
      display: inline-block;
      vertical-align: middle;
    }
    p.label{
      width: 100px;
      font-weight: 600;
      text-align: right;
      margin-right: 22px;
      margin-bottom: 0px;
      line-height: 33px;
    }
    input{
      display: inline-block;
      width: 250px;
      height: 44px;
      color: #0D303F;
      padding-left: 14px;
      padding-right: 14px;
      background-color: rgb(246,246,246);
      border: 1px solid rgb(227,228,229);
      border-radius: 4px 4px 0px 0px;
      text-align: left;
      &:focus{
        outline: none;
      }
    }
    &.email input{
      border: none;
      background-color: white;
    }
  }

  .profile-pic.row{
    img{
      height: 70px;
      width: 70px;
      border-radius: 40px;
    }
    .profile-pic-img{
      height: 70px;
      width: 70px;
      border-radius: 40px;
      background-size: cover;
      background-position: center;
    }
    input[type="file"] {
      display: none;
    }
    .upload-btn{
      padding: 8px;
      margin-left: 10px;
      font-weight: 500;
      font-size: 14px;
      opacity: .8;
      cursor: pointer;
      transition: all 0.3s ease;
      border-radius: 4px;
      &:hover{
        opacity: 1;
        background-color: rgb(245,245,245);
      }
    }
  }

  .save-edits-btn{
    display: block;
    padding: 10px 30px;
    border: 1.5px solid rgb(220,220,220);
    border-radius: 4px;
    color: black;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: .5px;
    margin: 0 auto;
    margin-top: 30px;
    opacity: .75;
    transition: all 0.2s ease;
    outline: none;
    cursor: pointer;
    &:hover{
      border: 1.5px solid rgb(190,190,190);
      opacity: 1;
    }
    &:active, &:focus{
      outline: none;
    }
  }

}



.notifications{
  .row{
    margin: 0 auto;
    width: 440px;
    margin-bottom: 20px;
    & > *{
      display: inline-block;
      vertical-align: top;
    }
    .text{
      width: 390px;
      p:first-of-type{
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 6px;
      }
      p:last-of-type{
        font-size: 12px;
        font-weight: 500;
      }
    }
    .toggle-outer{
      height: 24px;
      width: 34px;
      background-color: white;
      border: 1px solid rgb(200,200,200);
      border-radius: 4px;
      padding: 3px;
      margin-left: 15px;
      margin-top: 12px;
      cursor: pointer;
      .toggle-inner{
        height: 16px;
        width: 16px;
        background-color: rgb(225,225,225);
        border-radius: 4px;
        transform: translateX(0px);
        transition: all 0.2s ease;
        &.active{
          transform: translateX(10px);
          background-color: #17C890;
        }
      }
    }
  }
}


@media only screen
and (min-device-width : 320px)
and (max-device-width : 480px) {

.profile{
  .row.profile-pic{
    p{
      display: none;
    }
  }
  .row{
    padding-left: 0px;
    p.label{
      text-align: left;
    }
  }
}

.notifications{
  .row{
    width: 100%;
    .text{
      width: 80%;
      p:last-of-type{
        display: none;
      }
    }
    .toggle-outer{
      margin-top: 0px;
    }
  }
}

}

</style>
